<template>
  <qz-text-field
    class="text-input"
    :value="value"
    :class="inputClasses"
    :placeholder="helpers.getPlaceholderResponsiveText(placeholder || '', isMobile)"
    :error-messages="errorMessages"
    :maxlength="maxLength"
    :data-test="snakeCase(dataTest)"
    @input="$emit('input', $event)"
    @blur="onBlur"
  />
</template>

<script>
import { upperFirst, snakeCase } from 'lodash';

export default {
  name: 'text-input',
  inject: [
    'helpers',
  ],
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      default: null,
      validator: value => (typeof value === 'string') || value === false,
    },
    maxLength: {
      type: Number,
      default: null,
    },
    textTransform: {
      type: String,
      default: 'capitalize',
      validator: value => ['uppercase', 'lowercase', 'capitalize', 'none'].includes(value),
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    dataTest: {
      type: String,
      default: null,
    },
  },
  computed: {
    isMobile () { return this.$vuetify.breakpoint.smAndDown; },
    inputClasses () {
      return {
        'is-capitalized-input': this.textTransform === 'capitalize',
        'is-uppercase-input': this.textTransform === 'uppercase',
        'is-lowercase-input': this.textTransform === 'lowercase',
      };
    },
  },
  methods: {
    onBlur () {
      if (!this.value) return;

      // Select leading and trailing spaces and replace multiple spaces with one
      let val = this.value.trim().replace(/\s+/g, ' ');

      if (this.textTransform === 'uppercase') {
        val = val.toUpperCase();
      }

      if (this.textTransform === 'lowercase') {
        val = val.toLowerCase();
      }

      if (this.textTransform === 'capitalize') {
        val = upperFirst(val.split('')
          .map((letter, i) => / |-/.test(val[i - 1]) ? letter.toUpperCase() : letter.toLowerCase())
          .join(''));
      }

      this.$emit('input', val);
    },
  },
  setup () {
    return {
      snakeCase,
    };
  },
};
</script>

<style scoped lang="scss">
.is-uppercase-input {
  &::v-deep {
    input {
      text-transform: uppercase;
    }
  }
}

.is-lowercase-input {
  &::v-deep {
    input {
      text-transform: lowercase;
    }
  }
}

.is-capitalized-input {
  &::v-deep {
    input:not(::placeholder) {
      text-transform: capitalize;
    }
  }
}

.text-input {
  &::v-deep input::placeholder {
    text-transform: initial;
  }
}
</style>
